module.exports = __webpack_public_path__ + "static/media/logo512.146c4526.png";